/// <amd-module name="Test/TestResultsSettings/Components/TestResultsSettingsView" />
import * as React from "react";
import { TestResultsFlakySettingsView, ITestSettingsProps} from "Test/TestResultsSettings/Components/TestResultsFlakySettingsView";
import { TestResultsNewTestsLoggingSettingsView } from "Test/TestResultsSettings/Components/TestResultsNewTestsLoggingSettingsView";
import * as Resources from "Test/TestResultsSettings/Resources";
import { Components, IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import {TestResultsSettingsStore} from "Test/TestResultsSettings/Store/TestResultsSettingsStore";
import { Header, TitleSize } from "VSSUI/Header";

export interface IMainSettingsProps {}

class PipelineTestResultsSettingsView extends VssComponent<IVssComponentProperties> {
    private _store: TestResultsSettingsStore;
    constructor(props:IMainSettingsProps, context: IVssComponentContext){
        super(props, context);
        this._store = new TestResultsSettingsStore({
            pageContext: context.pageContext
        });
        this.state = this._store.getState();
    }

    public componentDidMount(){
        this._store.getTestResultsSettings();
    }

    public render(): JSX.Element {
        const props = {state:this.state, store:this._store} as ITestSettingsProps
        return (
            <div className="settings-view">
                <Header title={Resources.TestManagementText} titleSize={TitleSize.Large} />
                <div className="flaky-section">
                    <TestResultsFlakySettingsView {...props}/>
                </div>
                <div className="newTest-section">
                    <TestResultsNewTestsLoggingSettingsView {...props}/>
                </div>
            </div>
        );
    }
}

Components.add("pipelines-test-results-settings-view", PipelineTestResultsSettingsView);
